// Mock data for Serene Sparkle

export const services = [
  {
    id: 'house-cleaning',
    title: 'House Cleaning',
    description: 'Professional residential cleaning services for homes of all sizes. From routine maintenance to deep cleaning, we ensure every corner sparkles.',
    tasks: ['Dusting and surface cleaning', 'Vacuuming and mopping floors', 'Kitchen and bathroom sanitization', 'Trash removal', 'General tidying'],
    idealFor: 'Homeowners, tenants, busy families',
    image: 'https://images.unsplash.com/photo-1647381518264-97ff1835026f'
  },
  {
    id: 'commercial-cleaning',
    title: 'Commercial Cleaning',
    description: 'Tailored cleaning solutions for offices, retail spaces, clinics, and commercial properties. Maintain a professional environment that impresses clients and staff.',
    tasks: ['Office and desk cleaning', 'Floor care and maintenance', 'Restroom sanitization', 'Window and glass cleaning', 'Reception area upkeep'],
    idealFor: 'Offices, clinics, retail spaces, commercial buildings',
    image: 'https://images.unsplash.com/photo-1577412647305-991150c7d163'
  },
  {
    id: 'specialist-cleaning',
    title: 'Specialist Cleaning',
    description: 'Expert deep cleaning services including carpet cleaning, post-construction cleanup, and appliance deep cleaning for ovens and fridges.',
    tasks: ['Carpet steam and deep cleaning', 'Post-construction dust and debris removal', 'Oven and fridge deep cleaning', 'Upholstery cleaning', 'Hard-to-reach area cleaning'],
    idealFor: 'Post-renovation properties, deep cleaning needs, maintenance schedules',
    image: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac'
  }
];

export const packages = [
  {
    id: 'standard-residential',
    title: 'Standard Residential Cleaning',
    description: 'Regular home cleaning services to keep your space fresh and welcoming.',
    included: ['All standard cleaning tasks', 'Flexible scheduling', 'Eco-friendly products', 'Trusted, trained staff'],
    schedules: ['Weekly', 'Bi-weekly', 'Monthly'],
    addOns: ['Carpet deep clean', 'Oven cleaning', 'Fridge deep clean', 'Window cleaning']
  },
  {
    id: 'standard-commercial',
    title: 'Standard Commercial Cleaning',
    description: 'Consistent, professional cleaning for your business premises.',
    included: ['Office and workspace cleaning', 'Restroom sanitization', 'Floor care', 'Customizable schedule'],
    schedules: ['Daily', 'Weekly', 'Bi-weekly'],
    addOns: ['Carpet cleaning', 'Window cleaning', 'Deep sanitization', 'After-hours service']
  },
  {
    id: 'office-deep-cleaning',
    title: 'Office Deep Cleaning',
    description: 'Thorough, detailed cleaning for a fresh start or maintenance.',
    included: ['Complete workspace sanitization', 'Carpet and upholstery cleaning', 'Kitchen and break room deep clean', 'Window and blind cleaning'],
    schedules: ['Quarterly', 'Bi-annually', 'One-time'],
    addOns: ['Air duct cleaning', 'High-touch surface sanitization', 'Floor polishing']
  },
  {
    id: 'move-in-out',
    title: 'Move-In / Move-Out Cleaning',
    description: 'Complete property cleaning for moving transitions.',
    included: ['Deep clean of all rooms', 'Kitchen and bathroom sanitization', 'Window and door cleaning', 'Cabinet and drawer cleaning'],
    schedules: ['One-time service'],
    addOns: ['Carpet steam cleaning', 'Wall washing', 'Garage cleaning']
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Emma R.',
    role: 'Homeowner',
    text: 'Serene Sparkle turned our post-renovation chaos into a spotless, welcoming home - professional, fast and detail-oriented. We couldn\'t be happier!',
    rating: 5
  },
  {
    id: 2,
    name: 'Dr. S. Patel',
    role: 'Clinic Manager',
    text: 'Our clinic demands high standards. Serene Sparkle delivered impeccable, hygienic cleaning every visit - highly recommended.',
    rating: 4
  },
  {
    id: 3,
    name: 'Mark L.',
    role: 'Office Manager',
    text: 'The team was punctual, thorough and left our office sparkling. Clients even noticed the difference - great value and dependable service.',
    rating: 3
  },
  {
    id: 4,
    name: 'Sarah T.',
    role: 'Landlord',
    text: 'Used Serene Sparkle for three end-of-tenancy cleans now. Each time the property was left immaculate. My tenants are always impressed on move-in day.',
    rating: 5
  },
  {
    id: 5,
    name: 'James K.',
    role: 'Restaurant Owner',
    text: 'After a private event, the team had our venue looking brand new by morning. Quick turnaround and very reasonable pricing for the quality of work.',
    rating: 4
  },
  {
    id: 6,
    name: 'Priya M.',
    role: 'Working Parent',
    text: 'Having a regular weekly clean has been life-changing for our family. The house always smells fresh and the team are lovely with our kids and pets.',
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: 'How do I book a cleaning service?',
    answer: 'Simply fill out our quote request form with your details and preferences, and we\'ll respond within 24-48 hours with a customized quote.'
  },
  {
    id: 2,
    question: 'What payment options do you accept?',
    answer: 'We accept all major credit cards, debit cards, and online payments through our secure payment system.'
  },
  {
    id: 3,
    question: 'Do you bring your own cleaning supplies?',
    answer: 'Yes, we bring all necessary cleaning supplies and equipment. We use eco-friendly, safe products as standard.'
  },
  {
    id: 4,
    question: 'Are your cleaners insured and background-checked?',
    answer: 'Absolutely. All our team members are fully insured, background-checked, and professionally trained to ensure your safety and peace of mind.'
  },
  {
    id: 5,
    question: 'Do you offer a satisfaction guarantee?',
    answer: 'Yes! If you\'re not completely satisfied with our service, let us know within 24 hours and we\'ll make it right at no extra charge.'
  },
  {
    id: 6,
    question: 'What is your cancellation policy?',
    answer: 'We require 24 hours notice for cancellations or rescheduling. Cancellations with less notice may incur a fee.'
  },
  {
    id: 7,
    question: 'How do you determine pricing?',
    answer: 'Pricing depends on the size of your space, type of cleaning needed, and frequency. We provide free, no-obligation quotes tailored to your needs.'
  },
  {
    id: 8,
    question: 'How often should I schedule cleaning services?',
    answer: 'It depends on your needs. Weekly or bi-weekly is ideal for busy households, while monthly works well for maintenance cleaning.'
  },
  {
    id: 9,
    question: 'Do you follow COVID-safe cleaning practices?',
    answer: 'Yes, we follow all health guidelines including sanitizing high-touch surfaces, proper ventilation, and using hospital-grade disinfectants.'
  },
  {
    id: 10,
    question: 'Are pets a problem during cleaning?',
    answer: 'Not at all! We love pets. Just let us know about your furry friends so we can ensure their safety and comfort during our visit.'
  }
];

export const mockQuotes = [];
